import { Component, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { JobFileContainer } from '@core/models/job-file/job-file-container.model';
import { DropdownOption } from '../custom-dropdown/custom-dropdown.component';

@Component({
  selector: 'hmt-job-plan-order-header',
  templateUrl: './job-plan-order-header.component.html',
  styleUrls: ['./job-plan-order-header.component.scss'],
  standalone: false
})
export class JobPlanOrderHeaderComponent implements OnChanges {
  @Input() showHeader = false;
  @Input() showSearch = false;
  @Input() orderCount = 0;
  @Input() searchText = '';
  @Input() showMoveDropdown = false;
  @Input() containers: JobFileContainer[] = [];
  @Input() selectedLoadId: string = '';
  @Input() showAddButton = false;
  @Input() jobType?: string;
  @Output() searchTextChange = new EventEmitter<string>();
  @Output() loadSelected = new EventEmitter<string>();
  @Output() loadMoveClicked = new EventEmitter<string>();
  @Output() addButtonClicked = new EventEmitter<void>();

  onSearchChange(): void {
    this.searchTextChange.emit(this.searchText);
  }

  onLoadChange(): void {
    // Just update the model, don't emit yet
    // The selectedLoadId is already updated via [(ngModel)]
  }

  onMoveButtonClick(): void {
    this.loadMoveClicked.emit(this.selectedLoadId);
  }

  ngOnChanges(changes: SimpleChanges): void {
    // A selected load dropped from the options (e.g. it got locked) must not stay selected.
    if (changes['containers'] && this.selectedLoadId && !this.loadIds.includes(this.selectedLoadId)) {
      this.selectedLoadId = '';
    }
  }

  get loadIds(): string[] {
    return this.containers.map(container => container.containerId).filter(id => !!id);
  }

  get loadOptions(): DropdownOption[] {
    return [
      { value: '', label: 'Select a Load' },
      ...this.loadIds.map(loadId => ({ value: loadId, label: loadId }))
    ];
  }

  onAddButtonClick(): void {
    this.addButtonClicked.emit();
  }
}

